import c from './cohort-filters.module.scss';
import { Accordion, Checkbox } from '@monash/portal-react';

const CohortFilters = ({
  options: sectionedOptions,
  value: valueProp,
  onChange,
}) => {
  const handleCheck = (optionValue, e) => {
    const checked = e.target.checked;
    const newValue = checked
      ? [...valueProp, optionValue]
      : valueProp.filter((v) => v !== optionValue);
    onChange(newValue);
  };

  return (
    <Accordion
      useCustomStyles
      className={c.cohortAccordion}
      stylesheet={c}
      hasExpandAll={false}
      items={sectionedOptions.map((location) => {
        return {
          title: location.text,
          content: (
            <div>
              {location.options.map((option) => {
                const { value, text } = option;

                return (
                  <Checkbox
                    key={value}
                    on={valueProp?.includes(value)}
                    onChange={(e) => handleCheck(value, e)}
                    text={text}
                  />
                );
              })}
            </div>
          ),
        };
      })}
    />
  );
};

export default CohortFilters;
